module.exports =
  accepted:  [false, Number]
  max:       600
  secondary: false
  small:     200
  value:     false
